import { useLandingStore } from "src/modules/pe-landing-module/data/store"
import { getLandingContainer } from "../../../utils/getLandingContainer"
import { SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"

export const clearEdit = () => {
    const landing       = getLandingContainer()
    // unlock over sections
    landing.querySelectorAll(".landing-section-container.landing-gap.section-lock").forEach(section => {
        section?.classList.remove("section-lock") 
    })
    // unlock all outside element as exists
    landing.querySelector(".landing-content-edit-form")?.classList.remove("d-none")
    landing.querySelector(".landing-content-click-form")?.classList.remove("d-none")

    // unlock all over elements in this section
    landing.querySelector(".landing-section-edit-form.d-none")?.classList.remove("d-none")
    landing.querySelector(".landing-section-edit-container.d-none")?.classList.remove("d-none")
    landing.querySelector(".landing-section-marking-cont.d-none")?.classList.remove("d-none")
    landing.querySelector(".landing-section-top-padding-handler.d-none")?.classList.remove("d-none")
    landing.querySelector(".landing-section-bottom-padding-handler.d-none")?.classList.remove("d-none")
    landing.querySelector(".landing-section-container-handler.d-none")?.classList.remove("d-none")
    landing.querySelector(".landing-section-title-container.section-lock")?.classList.remove("section-lock")
    landing.querySelector(".landing-section-bg-color.section-lock")?.classList.remove("section-lock")
    landing.querySelector(".landing-section-bg-image.section-lock")?.classList.remove("section-lock")
    landing.querySelector(".landing-delimiter.section-lock")?.classList.remove("section-lock")         
    const floats = landing.querySelectorAll(`.landing-floats-container.section-lock`)
    floats.forEach((float: Element) => float.classList.remove("section-lock"))        
    landing.querySelectorAll(".landing-content-container.section-lock").forEach((meat: Element) =>  meat.classList.remove("section-lock") ) 
    useLandingStore.setState({
        editElement: null,
        doubleClickType: SELECT_TYPE.CONTENT
    })  
    
}